import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateMultiCartComment } from 'api/cart/updateMultiCartComment'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { COMMENT_QUERY_KEY } from 'constants/comments'

interface UpdateCommentParams {
  multiCartId: string
  commentId: string
  text: string
}

export function useUpdateMultiCartComment() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: UpdateCommentParams) => updateMultiCartComment(
      params.multiCartId,
      params.commentId,
      params.text
    ),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [COMMENT_QUERY_KEY, variables.multiCartId] })
    },
    onError: (error: Error) => {
      showSnackbar(`Failed to update comment: ${error.message}`, 'critical')
    }
  })
}
